import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomeBackupPage = lazy(() => import('../pages/home_backup/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const InvitePage = lazy(() => import('../pages/invite/page'));
const DownloadPage = lazy(() => import('../pages/download/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/invite',
    element: <InvitePage />,
  },
  {
    path: '/download',
    element: <DownloadPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
